var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"spiner"}),_c('p',[_vm._v("Your connection is being set up. This might take up to a minute. Please wait.")])])
}]

export { render, staticRenderFns }